/**
 * ChannelWizardPage — dispatcher that renders the correct wizard
 * based on the :type route param (/channels/new/:type).
 */

import { useParams, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import type { ChannelType } from '@/features/channels/types';
import { TeamsBotWizardPage } from './TeamsBotWizardPage';
import { SlackWizardPage } from './SlackWizardPage';
import { WhatsAppWizardPage } from './WhatsAppWizardPage';
import { TelegramWizardPage } from './TelegramWizardPage';

const VALID_TYPES: ChannelType[] = ['teams', 'slack', 'whatsapp', 'telegram'];

export function ChannelWizardPage() {
  const { type } = useParams<{ type: string }>();
  const navigate = useNavigate();

  // Redirect to /channels if type is unknown
  useEffect(() => {
    if (type && !VALID_TYPES.includes(type as ChannelType)) {
      navigate('/channels', { replace: true });
    }
  }, [type, navigate]);

  switch (type as ChannelType) {
    case 'teams':
      return <TeamsBotWizardPage />;
    case 'slack':
      return <SlackWizardPage />;
    case 'whatsapp':
      return <WhatsAppWizardPage />;
    case 'telegram':
      return <TelegramWizardPage />;
    default:
      return null;
  }
}
